export default __webpack_public_path__ + "static/2-124493ade9edd179b43ff08923917866.jpeg";